import React, { useEffect, useRef, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import axios from "axios";

import Header from './../components/Header'
import Description from './../components/DescriptionDayOfOpenDoors'
import Footer from "./../components/Footer";
import Loading from "./../components/Loading";

const Step20_Participant = () => {
    const [loading, setLoading] = useState(false);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [resources, setResources] = useState({});
    const [orderId, setOrderId] = useState("");
    const [agbAccepted, setAgbAccepted] = useState(false);
    const [token, setToken] = useState(sessionStorage.getItem("token"));
    const [errors, setErrors] = useState("");

    const [buyerInfo, setBuyerInfo] = useState({
        salutation: "",
        firstName: "",
        name: "",
        email: "",
        street: "",
        city: "",
        postCode: "",
        countryId: 176, // Default to Switzerland
    });

    const navigate = useNavigate();
    const baseUrl = process.env.REACT_APP_BASEURL_API;
    const language = "de"; // Default language

    const contentRef = useRef(null);

    useEffect(() => {
        if (resources && Object.keys(resources).length > 0) {
            if (contentRef.current) {
                window.scrollTo({ top: contentRef.current.offsetTop - 50 });
            }
        }
    }, [resources]);

    useEffect(() => {
        if (token) {
            axios.defaults.headers.common["Authorization"] = "Bearer " + token;
        }

        let currentOrderId = sessionStorage.getItem("orderId");

        if (currentOrderId > 0) {
            setOrderId(currentOrderId);
        }

        requestResources();
    }, []);

    const requestResources = async () => {
        await axios
            .get(`form/resources/de`)
            .then((res) => {
                setResources(res.data?.translation);
            })
            .catch((error) => console.error(error.response.data));
    };

    const onInputChange = (e) => {
        const { name, value, type, checked } = e.target;
        setBuyerInfo((prevBuyerInfo) => ({
            ...prevBuyerInfo,
            [name]: type === 'checkbox' ? checked : value
        }));
    };

    const validateEntries = () => {
        if (!(buyerInfo.salutation && buyerInfo.salutation.trim() !== "") ||
            !(buyerInfo.firstName && /^.{1,70}$/.test(buyerInfo.firstName)) ||
            !(buyerInfo.name && /^.{1,70}$/.test(buyerInfo.name)) ||
            !(buyerInfo.street && /^.{1,70}$/.test(buyerInfo.street)) ||
            !(buyerInfo.postCode && /^.{1,70}$/.test(buyerInfo.postCode)) ||
            !(buyerInfo.city && /^.{1,70}$/.test(buyerInfo.city)) ||
            !agbAccepted) {
            setErrors(resources?.FillMandatoryFields);
            return false;
        }
        else if (!(buyerInfo.email && /^\S+@\S+\.\S+$/.test(buyerInfo.email))) {
            setErrors(resources?.EmailNotCorrect);
            return false;
        }
        setErrors("");
        return true;
    }

    const addAddressToBasket = async () => {
        const beginTime = sessionStorage.getItem("BeginTime")?.slice(0, 5);

        const addressBody = {
            salutation: buyerInfo.salutation,
            firstName: buyerInfo.firstName,
            name: buyerInfo.name,
            street: buyerInfo.street,
            postCode: buyerInfo.postCode,
            city: buyerInfo.city,
            email: buyerInfo.email,
            countryId: buyerInfo.countryId,
            code2: beginTime,
        };

        await axios
            .put(`${baseUrl}/Order/${orderId}/Address`, addressBody)
            .then(() => {
                finishFreeOrder();
            })
            .catch((error) => {
                console.error(error.response.data);
                navigate(`/${language}/home`)
            });
    };

    const finishFreeOrder = async () => {
        await axios
            .put(`${baseUrl}/ShopBasket/Order/${orderId}/PaymentType/5`)
            .then(() => {
                confirmShopbasketByOrderId(orderId);
                navigate(`/${language}/tag-der-offenen-tuer/confirmation/${orderId}`);
            })
            .catch((error) => {
                console.error(error.response.data);
                setErrors(resources?.ErrorOccurred || "An error occurred");
                setIsSubmitting(false);
            });
    };

    const confirmShopbasketByOrderId = async (orderId) => {
        try {
            const res = await axios.put(`${baseUrl}/ShopBasket/Order/${orderId}/Confirm`);
        } catch (error) {
            console.error(error)
        }
    };


    const handleSubmit = async () => {
        // Prevent double submission
        if (isSubmitting) {
            return;
        }

        if (validateEntries()) {
            setIsSubmitting(true);

            try {
                await addAddressToBasket();
            } catch (error) {
                console.error("Error during submission:", error);
                setErrors(resources?.ErrorOccurred || "An error occurred");
                setIsSubmitting(false);
                window.scrollTo({ top: 0, behavior: 'smooth' });
            }
        } else {
            window.scrollTo({ top: 0, behavior: 'smooth' });
        }
    };

    return (
        <div>
            <Header resources={resources} title={resources?.DayOfOpenDoor_HomeTitle} />
            {loading ? (
                <Loading
                    alignment="center"
                    color="#d3d3d3"
                    bgColor="#fff"
                    top="50%"
                />
            ) : (
                <>
                    <div className="container page-container">

                        <div className="mt-4 page-container-smaller">

                            <Description resources={resources} />

                            <div className="mt-5 mb-2">
                                <h2>Teilnehmerinformationen</h2>
                                <p>Bitte füllen Sie Ihre persönlichen Daten aus.</p>
                            </div>

                            {errors !== "" && (
                                <div className="mt-4 alert alert-danger" role="alert">
                                    {errors}
                                </div>
                            )}

                            {/* Buyer Information Form Section */}
                            <div ref={contentRef} className="mt-5 mb-5 buyer-information-box">

                                <span className="mandatory">*</span><span>{resources?.BuyerMandatoryFields}</span>

                                <h5 className="subtitle mt-4 mb-5">{resources?.BuyerInformation}</h5>

                                {/* Salutation */}
                                <div className="mb-4">
                                    <label className="form-label text-buyer-input" htmlFor="salutation">
                                        {resources?.BuyerSalutation} <span className="mandatory">*</span>
                                    </label>
                                    <select
                                        name="salutation"
                                        id="salutation"
                                        className="form-select"
                                        value={buyerInfo.salutation}
                                        onChange={onInputChange}
                                    >
                                        <option value="">{resources?.BuyerSalutationChoose}</option>
                                        <option value={resources?.Mr}>{resources?.Mr}</option>
                                        <option value={resources?.Ms}>{resources?.Ms}</option>
                                        <option value={resources?.Diverse}>{resources?.Diverse}</option>
                                    </select>
                                </div>

                                {/* First Name */}
                                <div className="mb-4">
                                    <label className="form-label text-buyer-input" htmlFor="firstName">
                                        {resources?.BuyerFirstname} <span className="mandatory">*</span>
                                    </label>
                                    <input
                                        type="text"
                                        name="firstName"
                                        className="form-control"
                                        value={buyerInfo.firstName}
                                        id="firstName"
                                        onChange={onInputChange}
                                    />
                                </div>

                                {/* Last Name */}
                                <div className="mb-4">
                                    <label className="form-label text-buyer-input" htmlFor="name">
                                        {resources?.BuyerLastname} <span className="mandatory">*</span>
                                    </label>
                                    <input
                                        type="text"
                                        name="name"
                                        className="form-control"
                                        value={buyerInfo.name}
                                        id="name"
                                        onChange={onInputChange}
                                    />
                                </div>

                                {/* Street */}
                                <div className="mb-4">
                                    <label className="form-label text-buyer-input" htmlFor="street">
                                        {resources?.BuyerStreet} <span className="mandatory">*</span>
                                    </label>
                                    <input
                                        type="text"
                                        name="street"
                                        className="form-control"
                                        value={buyerInfo.street}
                                        id="street"
                                        onChange={onInputChange}
                                    />
                                </div>

                                {/* Postcode */}
                                <div className="mb-4">
                                    <label className="form-label text-buyer-input" htmlFor="postCode">
                                        {resources?.BuyerPostcode} <span className="mandatory">*</span>
                                    </label>
                                    <input
                                        type="text"
                                        name="postCode"
                                        className="form-control"
                                        value={buyerInfo.postCode}
                                        id="postCode"
                                        onChange={onInputChange}
                                    />
                                </div>

                                {/* City */}
                                <div className="mb-4">
                                    <label className="form-label text-buyer-input" htmlFor="city">
                                        {resources?.BuyerCity} <span className="mandatory">*</span>
                                    </label>
                                    <input
                                        type="text"
                                        name="city"
                                        className="form-control"
                                        value={buyerInfo.city}
                                        id="city"
                                        onChange={onInputChange}
                                    />
                                </div>

                                {/* Email */}
                                <div className="mb-4">
                                    <label className="form-label text-buyer-input" htmlFor="email">
                                        {resources?.BuyerEmail} <span className="mandatory">*</span>
                                    </label>
                                    <input
                                        type="email"
                                        name="email"
                                        className="form-control"
                                        value={buyerInfo.email}
                                        id="email"
                                        onChange={onInputChange}
                                    />
                                </div>

                                {/* AGB */}
                                <div className="mt-5">
                                    {/*<p className="form-label agb-label">AGB & DATENSCHUTZBESTIMMUNGEN *</p>*/}
                                    <div className="agb-checkbox-row">
                                        <input
                                            type="checkbox"
                                            id="agbCheckbox"
                                            checked={agbAccepted}
                                            onChange={(e) => setAgbAccepted(e.target.checked)}
                                            className="agb-checkbox"
                                        />
                                        <label htmlFor="agbCheckbox"
                                            className="agb-text"
                                            style={{ marginTop: "6px" }}
                                        >
                                            Ich akzeptiere die <a href="https://cms.luks.ch/sites/default/files/2026-06/Teilnahmebedingungen_Tag%20der%20offenen%20T%C3%BCr.pdf" target="_blank" rel="noopener noreferrer">Teilnahmebedingungen</a>.
                                        </label>
                                    </div>
                                </div>

                                <div className="row mt-5">
                                    <div className="col-12">
                                        <button
                                            className="btn btn-custom btn-register"
                                            onClick={handleSubmit}
                                            disabled={isSubmitting}
                                        >
                                            Ich melde mich für den Rundgang verbindlich an
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <Footer />
                </>
            )}
        </div>
    )
}

export default Step20_Participant
